import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { NotificationListItem } from '@/models/Notification';
import NotificationPanelItemLabel from '@/components/toolbar/notification/NotificationPanelItemLabel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanelItem',
  props: {
  item: { type: Object as PropType<NotificationListItem>, required: true }
},
  setup(__props) {



return { __sfc: true,NotificationPanelItemLabel }
}

})